import React from "react";
import { SVGAnnotationProps } from "../index";
import { useObjectsState } from "../../../contexts/ObjectsProvider";
import { HighlightAnnotation } from "../HighlightAnnotation";

// import HighlightAnnotation from "../hooks/HighlightAnnotation";

export function SVGSquareLetter({
  x,
  y,
  objectId,
  onMouseDown,
  isDisplayed,
  rotate,
  height,
  width,
  zIndex,
  opacity,
  borderColor,
  strokeWidth,
  backgroundColor,
  fontColor,
}: SVGAnnotationProps & { fontColor?: string }) {
  const alphas = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  const { annotations } = useObjectsState();
  const circleLetterAnnotations = annotations.filter((annotation: any) => annotation.type === "squareLetter");
  const index = circleLetterAnnotations.findIndex((annotation: any) => annotation.objectId === objectId);
  const transformString = `translate(${x}px, ${y}px) rotate(${rotate ?? 0}deg)`;
  return (
    <svg
      viewBox="0 0 100 100"
      data-objectid={objectId}
      id={`squareLetter-${objectId}`}
      className="annotation"
      name="squareLetter"
      onMouseDown={(e: React.MouseEvent<SVGSVGElement>) => {
        onMouseDown(e, objectId);
      }}
      preserveAspectRatio="xMinYMin meet"
      tabIndex={0}
      style={{
        transform: transformString,
        width: `${width}px`,
        height: `${height}px`,
        zIndex: zIndex,
        opacity: isDisplayed ? opacity : 0.5,
        filter: isDisplayed ? "none" : "grayScale(100%)",
      }}
    >
      <rect
        x="1.5"
        y="1.5"
        height="97"
        width="97"
        stroke={`${borderColor ?? "white"}`}
        strokeWidth={`${strokeWidth || "3"}`}
        fill={`${backgroundColor ?? "#4B4F58"}`}
      ></rect>
      <HighlightAnnotation objectId={objectId} id="glow-rect-for-square" />
      <text
        className="step-text"
        x="50"
        y="50"
        dy="26.5"
        dx="0.0em"
        textAnchor="middle"
        fill={`${fontColor ? fontColor : "white"}`}
        // style={{transform: 'translate(-2px, -1px)'}}
      >
        {alphas[index]}
      </text>
    </svg>
  );
}
